import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

const actionBtnClass = "bg-gradient-to-r from-[#FF751F] to-[#FFBD25] hover:from-[#FF751F] hover:to-[#FFD04A] text-white font-semibold";

export const ScenarioCompleteDialog = ({ open, onOpenChange, scenarioNumber, onBack, onContinue }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid="scenario-complete-dialog" className="bg-white border-2" style={{ borderColor: '#FFBD25' }}>
      <AlertDialogHeader>
        <AlertDialogTitle className="text-2xl text-gray-900">Scenario {scenarioNumber} Complete!</AlertDialogTitle>
        <AlertDialogDescription className="text-base pt-2 text-gray-700">Ready for the next scenario?</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="scenario-back-btn" onClick={onBack}>Go Back</AlertDialogCancel>
        <AlertDialogAction data-testid="scenario-continue-btn" onClick={onContinue} className={actionBtnClass}>Yes, Continue</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const FinalConfirmationDialog = ({ open, onOpenChange, onReview, onSubmit }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid="final-confirmation-dialog" className="bg-white border-2 border-amber-400">
      <AlertDialogHeader>
        <AlertDialogTitle className="text-2xl text-gray-900 flex items-center gap-2">
          <AlertTriangle className="w-6 h-6 text-amber-500" />
          Submit Your Assessment?
        </AlertDialogTitle>
        <AlertDialogDescription asChild>
          <div className="text-base pt-4 space-y-3">
            <p className="text-gray-700 font-medium">This will lock your responses and generate your personalized report.</p>
            <p className="text-gray-600">Once submitted, you will not be able to change your answers. Please take a moment to review your responses if you wish to make any changes.</p>
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mt-4">
              <p className="text-sm text-amber-800">
                <strong>Tip:</strong> Use the &quot;Review Responses&quot; button to go back and verify your choices before final submission.
              </p>
            </div>
          </div>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter className="flex-col sm:flex-row gap-2">
        <AlertDialogCancel data-testid="review-responses-btn" onClick={onReview} className="w-full sm:w-auto">Review Responses</AlertDialogCancel>
        <AlertDialogAction data-testid="confirm-submit-btn" onClick={onSubmit} className={`w-full sm:w-auto ${actionBtnClass}`}>Submit & Generate Report</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const PathChangeWarningDialog = ({ open, onOpenChange, currentStage, onCancel, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid="path-change-dialog" className="bg-white border-2 border-amber-400">
      <AlertDialogHeader>
        <AlertDialogTitle className="text-xl text-gray-900 flex items-center gap-2">
          <AlertTriangle className="w-5 h-5 text-amber-500" />
          Change Your Response?
        </AlertDialogTitle>
        <AlertDialogDescription asChild>
          <div className="text-base pt-3 space-y-3">
            <p className="text-gray-700">Changing your response at this stage will alter the path of questions for the remaining stages in this scenario.</p>
            <p className="text-gray-600">
              Your answers for <strong>Stage {currentStage + 1}{currentStage === 1 ? " and Stage 3" : ""}</strong> in this scenario will need to be re-submitted based on your new selection.
            </p>
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mt-3">
              <p className="text-sm text-amber-800">
                <strong>Note:</strong> This only affects the current scenario. Your responses in other scenarios will remain unchanged.
              </p>
            </div>
          </div>
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel onClick={onCancel}>Keep Original Response</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className={actionBtnClass}>Yes, Change Response</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
